import React, { useState, useEffect } from "react";
import { getItems } from "../api/itemApi";
import { getClientsApi } from "../api/clientApi";
import { getProjectsApi } from "../api/projectApi";
import { createQuotationApi } from "../api/quotationApi";  
import { generateQuotePDF } from "../utils/generateQuotePDF";
const Quotation = () => {
  const [items, setItems] = useState([
    { name: "", description: "", qty: 1, rate: 0 }
  ]);

  const [itemOptions, setItemOptions] = useState([]);
  const [clients, setClients] = useState([]);
  const [projects, setProjects] = useState([]);

  const [selectedClient, setSelectedClient] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [additionalAmount, setAdditionalAmount] = useState(0);

  // FETCH DATA
  useEffect(() => {
    const fetchData = async () => {
      try {
        const itemRes = await getItems();
        const itemsData =
          itemRes.data.data?.items ||
          itemRes.data.items ||
          itemRes.data.data ||
          itemRes.data;

        setItemOptions(Array.isArray(itemsData) ? itemsData : []);

        const clientRes = await getClientsApi();
        const clientData =
          clientRes.data.data?.clients ||
          clientRes.data.clients ||
          clientRes.data.data ||
          clientRes.data;

        setClients(Array.isArray(clientData) ? clientData : []);

        const projectRes = await getProjectsApi();
        const projectData =
          projectRes.data.data?.projects ||
          projectRes.data.projects ||
          projectRes.data.data ||
          projectRes.data;

        setProjects(Array.isArray(projectData) ? projectData : []);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchData();
  }, []);

  // INPUT CHANGE
  const handleChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] =
      field === "qty" || field === "rate" ? Number(value) : value;
    setItems(newItems);
  };

  const addItem = () => {
    setItems([
      ...items,
      { name: "", description: "", qty: 1, rate: 0 }
    ]);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // CALCULATIONS
  const subtotal = items.reduce(
    (sum, item) => sum + item.qty * item.rate,
    0
  );

  const gst = subtotal * 0.18;
  const normalizedAdditionalAmount = Math.max(0, Number(additionalAmount) || 0);
  const total = subtotal + gst + normalizedAdditionalAmount;

  // 🔥 SAVE FUNCTION
  const handleSave = async () => {
    try {
      if (!selectedClient || !selectedProject) {
        alert("Please select client and project");
        return;
      }

      if (items.length === 0) {
        alert("Add at least one item");
        return;
      }

      const payload = {
        client: selectedClient,
        project: selectedProject,
        items,
        subtotal,
        gst,
        additionalAmount: normalizedAdditionalAmount,
        total,
      };

      const res = await createQuotationApi(payload);

      console.log("Saved:", res.data);
      alert("Quotation saved successfully");

    } catch (err) {
      console.error(err);
      alert("Error saving quotation");
    }
  };

 const handleDownloadPDF = () => {
  const selectedClientObj = clients.find(c => c._id === selectedClient);

  const quoteData = {
    client: {
      name: selectedClientObj?.name || "Client"
    },
    createdBy: {
      name: "Krushna Kadukar"
    },
    createdAt: new Date(),

    items: items.map((item, index) => ({
      sr: index + 1,
      name: item.name,
      material: item.description,
      finish: "-",
      qty: Number(item.qty) || 1,
      rate: Number(item.rate) || 0
    })),
    additionalAmount: normalizedAdditionalAmount,
    total
  };

  generateQuotePDF(quoteData);
};

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Create Quotation</h1>

      {/* CLIENT + PROJECT */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <select
          value={selectedClient}
          onChange={(e) => {
            setSelectedClient(e.target.value);
            setSelectedProject("");
          }}
          className="border p-2 rounded"
        >
          <option value="">Select Client</option>
          {clients.map((c) => (
            <option key={c._id} value={c._id}>
              {c.name}
            </option>
          ))}
        </select>

        <select
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
          className="border p-2 rounded"
        >
          <option value="">Select Project</option>
          {projects
            .filter((p) => !selectedClient || p.client === selectedClient)
            .map((p) => (
              <option key={p._id} value={p._id}>
                {p.name}
              </option>
            ))}
        </select>
      </div>

      {/* TABLE */}
      <table className="w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Item</th>
            <th className="p-2 border">Description</th>
            <th className="p-2 border">Qty</th>
            <th className="p-2 border">Rate</th>
            <th className="p-2 border">Amount</th>
            <th className="p-2 border">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td className="border p-1">
                <select
                  value={item.name}
                  onChange={(e) => {
                    const selected = itemOptions.find(
                      (i) => i.name === e.target.value
                    );

                    if (selected) {
                      handleChange(index, "name", selected.name);
                      handleChange(index, "rate", selected.price || 0);
                    }
                  }}
                  className="w-full border p-1"
                >
                  <option value="">Select Item</option>
                  {itemOptions.map((opt) => (
                    <option key={opt._id} value={opt.name}>
                      {opt.name} ({opt.category})
                    </option>
                  ))}
                </select>
              </td>

              <td className="border p-1">
                <input
                  value={item.description}
                  onChange={(e) =>
                    handleChange(index, "description", e.target.value)
                  }
                  className="w-full border p-1"
                />
              </td>

              <td className="border p-1">
                <input
                  type="number"
                  value={item.qty}
                  onChange={(e) =>
                    handleChange(index, "qty", e.target.value)
                  }
                  className="w-full border p-1"
                />
              </td>

              <td className="border p-1">
                <input
                  type="number"
                  value={item.rate}
                  onChange={(e) =>
                    handleChange(index, "rate", e.target.value)
                  }
                  className="w-full border p-1"
                />
              </td>

              <td className="border p-2 text-center">
                ₹ {item.qty * item.rate}
              </td>

              <td className="border p-2 text-center">
                <button
                  onClick={() => removeItem(index)}
                  className="text-red-500"
                >
                  ❌
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-4 flex justify-end">
        <label className="flex items-center gap-2">
          <span className="text-sm font-medium">Additional Amount:</span>
          <input
            type="number"
            min="0"
            step="0.01"
            value={additionalAmount}
            onChange={(e) => setAdditionalAmount(e.target.value)}
            className="border p-2 rounded text-right"
          />
        </label>
      </div>

      {/* BUTTONS */}
      <div className="mt-4 flex gap-4">
        <button
          onClick={addItem}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          + Add Item
        </button>

        <button
          onClick={handleSave}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          Save Quotation
        </button>

        <button
  onClick={handleDownloadPDF}
  className="bg-red-600 text-white px-4 py-2 rounded"
>
  Download PDF
</button>

      </div>

      {/* SUMMARY */}
      <div className="mt-6 text-right">
        <p>Additional Amount: Rs. {normalizedAdditionalAmount.toFixed(2)}</p>
        <p>Subtotal: ₹ {subtotal}</p>
        <p>GST (18%): ₹ {gst.toFixed(2)}</p>
        <h2 className="text-xl font-bold">Total: ₹ {total.toFixed(2)}</h2>
      </div>
    </div>
  );
};

export default Quotation;
